
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SupabaseAuthGuard } from "@/components/auth/SupabaseAuthGuard";
import Index from "./pages/Index";
import Calendar from "./pages/Calendar";
import Gestion from "./pages/Gestion";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Pointage from "./pages/Pointage";
import Profile from "./pages/Profile";
import Reports from "./pages/Reports";
import WeeklySummary from "./pages/WeeklySummary";
import AddAssignmentPage from "./pages/AddAssignmentPage";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={
              <SupabaseAuthGuard requireAuth={false}>
                <Index />
              </SupabaseAuthGuard>
            } />
            <Route path="/home" element={
              <SupabaseAuthGuard>
                <Home />
              </SupabaseAuthGuard>
            } />
            <Route path="/calendar" element={
              <SupabaseAuthGuard>
                <Calendar />
              </SupabaseAuthGuard>
            } />
            <Route path="/calendrier" element={<Navigate to="/calendar" replace />} />
            <Route path="/pointage" element={
              <SupabaseAuthGuard>
                <Pointage />
              </SupabaseAuthGuard>
            } />
            <Route path="/reports" element={
              <SupabaseAuthGuard>
                <Reports />
              </SupabaseAuthGuard>
            } />
            <Route path="/rapports" element={<Navigate to="/reports" replace />} />
            <Route path="/profile" element={
              <SupabaseAuthGuard>
                <Profile />
              </SupabaseAuthGuard>
            } />
            <Route path="/profil" element={<Navigate to="/profile" replace />} />
            <Route path="/gestion/*" element={
              <SupabaseAuthGuard requireRole="admin">
                <Gestion />
              </SupabaseAuthGuard>
            } />
            <Route path="/gestion/add-assignment" element={
              <SupabaseAuthGuard requireRole="admin">
                <AddAssignmentPage />
              </SupabaseAuthGuard>
            } />
            <Route path="/weekly-summary" element={
              <SupabaseAuthGuard>
                <WeeklySummary />
              </SupabaseAuthGuard>
            } />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
